// Yalnızca görsel biçimlendirme ve link yardımcıları. Demo veri/şifre üretimi yoktur.
export const formatBytes = (value = 0) => {
  const bytes = Number(value) || 0;
  if (bytes <= 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const power = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  return `${(bytes / 1024 ** power).toLocaleString('tr-TR', {
    maximumFractionDigits: power === 0 ? 0 : 1,
  })} ${units[power]}`;
};

export const formatDate = (date) => {
  if (!date) return '—';
  const value = new Date(date);
  return Number.isNaN(value.getTime()) ? '—' : new Intl.DateTimeFormat('tr-TR', {
    dateStyle: 'medium', timeStyle: 'short',
  }).format(value);
};

export const formatOnlyDate = (date) => {
  if (!date) return '—';
  const value = new Date(date);
  return Number.isNaN(value.getTime()) ? '—' : new Intl.DateTimeFormat('tr-TR', {
    dateStyle: 'medium',
  }).format(value);
};

export const getShareStatus = (share) => {
  if (share.revokedAt) return 'revoked';
  if (new Date(share.expiresAt).getTime() <= Date.now()) return 'expired';
  if (share.downloadLimit != null && share.downloadCount >= share.downloadLimit) return 'limited';
  return 'active';
};

const PUBLIC_SHARE_URL = "https://smsgrup.cloud"
//const PUBLIC_SHARE_URL = "http://localhost:3000"

export const buildShareUrl = (token) =>
  `${PUBLIC_SHARE_URL.replace(/\/$/, "")}/share/${encodeURIComponent(token)}`;

export const totalSize = (files = []) => files.reduce((sum, file) => sum + (Number(file.size) || 0), 0);
